import { z } from "zod"
import { workLineSchema } from "./mobiles"

// ─── Schemas ──────────────────────────────────────────────────────────────────

export const partyIdSchema = z.string().uuid("ID de parte inválido")

const googleMapsUrlSchema = z.preprocess(
  (value) => typeof value === "string" && value.trim() === "" ? null : value,
  z.string()
    .trim()
    .url("Ingresá un enlace válido de Google Maps")
    .max(2048)
    .refine((value) => {
      const url = new URL(value)
      if (url.protocol !== "https:") return false
      if (url.hostname === "maps.app.goo.gl" || url.hostname === "maps.google.com") return true
      if (url.hostname === "goo.gl") return url.pathname.startsWith("/maps")
      return url.hostname === "www.google.com" && url.pathname.startsWith("/maps")
    }, "El enlace debe ser de Google Maps")
    .nullable()
    .optional(),
)

export const createPartySchema = z.object({
  name:          z.string().min(1, "El nombre es obligatorio").max(250),
  externalId:    z.string().trim().max(50).nullable().optional(),
  address:       z.string().max(500).nullable().optional(),
  googleMapsUrl: googleMapsUrlSchema,
  cityId:    z.string().uuid().nullable().optional(),
  countryId: z.string().uuid().nullable().optional(),
  latitude:  z.number().min(-90).max(90).nullable().optional(),
  longitude: z.number().min(-180).max(180).nullable().optional(),
  workLines: z.array(workLineSchema).nullable().optional(),
})

export const updatePartySchema = createPartySchema.partial()

export const partyQuerySchema = z.object({
  deleted:  z.enum(["true", "false"]).optional(),
  search:   z.string().optional(),
  page:     z.coerce.number().int().min(1).optional().default(1),
  pageSize: z.coerce.number().int().min(1).max(500).optional().default(25),
})

// ─── Types ────────────────────────────────────────────────────────────────────

export type PartyId     = z.infer<typeof partyIdSchema>
export type CreateParty = z.infer<typeof createPartySchema>
export type UpdateParty = z.infer<typeof updatePartySchema>
export type PartyQuery  = z.infer<typeof partyQuerySchema>
